import React from "react";
import styled, { css } from "styled-components";

import { EVENTS_LABEL } from "../../../constants";

const TabButton = ({ tabs, activeTab, onTabChange }) => {
  return (
    <TabWrapper>
      {tabs.map(({ value, label }) => (
        <Tab
          key={value}
          active={value === activeTab ? "true" : undefined}
          onClick={() => onTabChange(value)}
        >
          {label}
        </Tab>
      ))}
    </TabWrapper>
  );
};

const TabWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 1px;
  gap: 1px;
`;

const Tab = styled.button`
  background-color: ${props => (props.active ? "#E7C11D" : "#f0f0f0")};
  color: black;
  border: none;
  /* min-width: 7rem; */
  height: 2.5rem;
  padding: 0 0.8rem;
  cursor: pointer;
  transition:
    background-color 0.3s,
    transform 0.3s; /* 트랜지션 효과 추가 */
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-weight: 500;
  font-size: 0.9rem;
  &:hover {
    background-color: ${props => (props.isActive ? "#E7C11D" : "#b0b0b0")};
  }

  ${props =>
    props.isActive &&
    css`
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 활성 탭 그림자 추가 */
      font-weight: bold;
    `}
`;

export default React.memo(TabButton);
